export tag FullscreenDisplay
	prop cover

	css .cover bgp:center bgs:cover w:100% h:100% tween: background-image 1s ease-in-out

	def render
		let imageUrl = `url('{cover}')`
		<self>
			<div.cover[bgi:{imageUrl}]>

